
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import coupon_empty from '@/assets/images/coupon_empty.png'
export default class CouponView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._couponBoxEl;
        this._applyEl = $('div.apply_goods_box');
        this.appCart = []
        this.numOne = 0
    }
    trialShopItem(item,index){
        if(item.items){
            return `<div class="clearfix info apply_good_text">
            <span class="fl" tag="cartShops" code="${index}" style="font-weight:bold;">购物车中的适用商品<i style="float:right" class="iconfont icon-arrow-down"></i></span>
            <div class="apply_goods_box" tag="apply_goods_box" data-status="${item.coupon.status}">
                            
            </div>
        </div>`
        }else{
            return `
            <div class="info coupon_detail_desc">
                <span class="fl">详细说明</span>
                <img class='fl iconfont icon-icon-test3' src="//p1.lefile.cn/product/adminweb/2020/12/28/lkZGHq3KhdDMOUZXeztwqaA4I-5708.png" alt="">
                <ul class="detail_desc_box">
            <li>${item.coupon.salesCouponTemplate.salesCouponInfo.description}</li>
            </ul>
            </div>
            `
        }
    }
    getItems(){
        let html = ''
        this._model._coupons.map((item,index) => {
            // console.log('ooooooooooooo',item)
            html += `<dl class="clearfix clstop">
            <dt class="fl coupon_left"><div>`;
            if (item.coupon.salesCouponTemplate.templeteType == 1) {
                //  金额券
                html += `<p class="price" style="font-size:22px;"><i>￥</i>${item.coupon.amount.showAmount}</p>`
            } else if (item.coupon.salesCouponTemplate.templeteType == 2) {
                //   免息券
                html += `<p class="price" style="font-size:18px;">${item.coupon.salesCouponTemplate.salesCouponInfo.title}</p>`
            } else if (item.coupon.salesCouponTemplate.templeteType == 3) {
                //   折扣券
                html += `<p class="price" style="font-size:22px;">${item.coupon.salesCouponTemplate.salesCouponInfo.title.split('.')[0]}<i style="font-style:normal;font-size:12px;">${item.coupon.salesCouponTemplate.salesCouponInfo.title.split('.')[1] != undefined ? "." +item.coupon.salesCouponTemplate.salesCouponInfo.title.split('.')[1] : ''}折</i></p>`
            }
            if (item.coupon.salesCouponTemplate.salesCouponInfo.condition) {
                html += `<p class="limit">${item.coupon.salesCouponTemplate.salesCouponInfo.condition.replace(/、/g,' ')}</p>`
            }
            html+=`</div></dt>
            <dd class="fl coupon_middle">`
            if (item.items && item.items.length > 0 && item.stip && !item.full) {
                html += `<h6 data-couponid="${item.coupon.salesCouponId}"><span title="${item.coupon.salesCouponTemplate.salesCouponInfo.name}">${item.coupon.salesCouponTemplate.salesCouponInfo.name}</span><a class='hoverColor' data-couponid="${item.coupon.salesCouponId}" style="margin-left:12px;" tag='onClickActive'>去凑单<i class="iconfont icon-arrow-right"></i></a></h6>`
            } else if (item.items && item.items.length > 0 && item.stip && item.full) {
                html += `<h6  data-couponid="${item.coupon.salesCouponId}"><span title="${item.coupon.salesCouponTemplate.salesCouponInfo.name}">${item.coupon.salesCouponTemplate.salesCouponInfo.name}</span><a data-couponid="${item.coupon.salesCouponId}"class='hoverColor'  style="margin-left:12px;" tag='onClickActive'>再逛逛<i class="iconfont icon-arrow-right"></i></a></h6>`
            } else {
                html += `<h6><span title="${item.coupon.salesCouponTemplate.salesCouponInfo.name}">${item.coupon.salesCouponTemplate.salesCouponInfo.name}</span></h6>`
            }
            html+=`<p>${item.coupon.salesCouponTemplate.salesCouponInfo.validityTime}</p>
            <p>${item.coupon.salesCouponTemplate.salesCouponInfo.terminal}</p>
            
            ${
                this.trialShopItem(item,index)
            }
            </dd>
            <dd class="fr coupon_right">`
            if (item.coupon.status == 0) {
                html+=`<button class="le_btn le_btn_solid" tag="onClickChSerList" data-couponid="${item.coupon.salesCouponId}">领取</button>`
            } else if(item.coupon.status == 1) {
                html+=`<img src="//p2.lefile.cn/product/adminweb/2020/12/09/fDA35vLT2b0PCZLdemClFqnGd-0768.png" alt="">`
            }
            html+=`</dd>
               
        </dl>`
        })

      return html
    }
    getChecked(item){
        if(item.checked){
            return `<i class="iconfont icon-checkeds checkbox" ></i>`
        }else{
            return `<i class="iconfont icon-unchecks checkbox" ></i>`
        }
    }
    getItemApply(){
        let html = ''
        this._model._arr.items.map((item,index) => {
            html += ` <li class="fl">
            <p class="thumb" tag="onClickActives" codes=${index}>
              ${this.getChecked(item)}
              <img  src="${item.imgUrl}" alt="">
            </p>
            <p class="a_price">¥${item.price.showAmount}</p>
            <p class="a_num">x${item.num}</p>
          </li>`
        })

      return html

    }

    renderEmpty() {
      return `
        <div style="display: flex; justify-content: center;padding-top: 60px;">
          <img src="${coupon_empty}" style="width: 180px;" />
        </div>
      `
    }

    render(){
        let html = "";
        
        html += `
        <ul class="clearfix" tag='mainsku_couponBox'>
            ${this.getItems()}
        </ul>`;

        if(!this._model._coupons.length) {
          html += this.renderEmpty()
        }
       
        $(this._parentEl).html($(html));
        
        
        this._el = $("ul[tag='mainsku_couponBox']");
        this._els = $('.apply_goods_box')
        this.regEvent();
    }
    regEvent(){
        let that = this;
        // 点击详细说明
        this._el.off("click",".coupon_detail_desc").on("click",".coupon_detail_desc",function(e){
            $(this).children('ul').toggleClass('cactive');
        })
        // 领取优惠券
        this._el.off("click","[tag=onClickChSerList]").on("click","[tag=onClickChSerList]",function(e){
            // alert(JSON.stringify(e))
            const currentCouponId = $(e.target).data("couponid")
            that._model.couponBindForOnce({salesCouponId:currentCouponId, goodsCode: that?._model?._parent?._id}).then(x=>{
                Alert.showTip("领券成功");
                
                // that._model.getCouponList().then(
                //     x=>{
                //         that._model.init(x.t); 
                //         that.render();   
                //         // 隐藏适用商品的弹窗
                //         $('.coupon_wrapper .apply_goods_box').hide();                              
                //     }
                // );
                
                // FIXME: https://jira.xpaas.lenovo.com/browse/SHOP-70878
                // 领券成功后立即拉取优惠卷列表会返回空，这里前端直接变更状态
                that._model._coupons.some((item) => {
                  if(item.coupon.salesCouponId === currentCouponId) {
                    item.coupon.status = 1
                    return true
                  }
                })
                that.render();
            }).catch(err =>{
                Alert.showTip(err);
            })
        })
        this._el.off("click","[tag=onClickActive]").on("click","[tag=onClickActive]",function(e){
            let couponId = $(this).attr('data-couponid');
            // 39263993b0723ef8
            window.location.href="./active.html?couponId="+couponId+'&tag=1';
        })
        
        this._els.off("click","[tag=onClickOKcancal]").on("click","[tag=onClickOKcancal]",function(){
            $(this).parents(".apply_good_text").find(".apply_goods_box").hide()
            $(this).parents(".content_item").find("[tag='cartShops']").removeClass("active")
            $(this).parents(".content_item").find("[tag='cartShops']").find('i.iconfont').removeClass('icon-arrow-down').addClass('icon-arrow-down')
        })
        // 更新选中
        this._els.off("click","[tag=onClickActives]").on("click","[tag=onClickActives]",function(){
            let arr = {}
            let arrp = []
             let status = $(this).parents("[tag=apply_goods_box]").attr('data-status');
            if(status == 1){
                that.numOne = 1
            }
            // 判断是已领取还是未领取
          

            let arrItem  = that._model._arr
            arrItem.items.map((item, index) => {
                if(index == $(this).attr('codes')){
                    arr = item
                    item.checked = !item.checked
                }
               
            })
            
            arrp = arrItem
            arr._invalid = false
            arr._itemId = arr.itemId
            arr._isChecked = arr.checked
           
            arr._purchaseEnable = true
            that._model.setActive(arr).then().catch(err => { 
                Alert.showTip(err);
            });
            let cartItemId = that._model._parent._itemId;
            let params ={
                checked: arr.checked,
                itemId: arr.itemId,
                cartItemId
            }
            that._model.setCouponCheckedCartItem(params).then(x=>{
                that._model.init(x.t); 
                // that.render();   
                // that.render();   
                // // 隐藏适用商品的弹窗
                // $('.coupon_wrapper .apply_goods_box').hide();   
                let arrsss = {}
                let opt = x.t
                opt.map((item, index) => {
                    if(that._model._arr.coupon.salesCouponId == item.coupon.salesCouponId){
                        arrsss = item
                    }
                })
                let htmls = ''
                $('.apply_goods_box').html('')
                that._model.modifyAppList(arrsss).then( res =>{
                    htmls += `<ul class="clearfix apply_goods_ul tag="apply_goods_ul">
                    ${that.getItemApply()}
                    </ul>
                    <p class="a_sum">${that._model._arr.stip ? that._model._arr.stip : ''}</p>
                    <p class="fr a_btn"><button class="le_btn le_btn_solid" tag="onClickOKcancal">确认</button></p>`
                    $('.apply_goods_box').append($(htmls));
                    if(that.numOne == 0 && arr._isChecked) {
                        Alert.showTip("记得领取优惠券");
                        that.numOne = 1
                    }
                }).catch(err => { 
                    Alert.showTip(err);
                    
                });

            }).catch(err => { 
                Alert.showTip(err);
                
            });
        })
        this._el.off("click","[tag=cartShops]").on("click","[tag=cartShops]",function(){
            let arr = {}
            that.numOne = 0
            $('.coupon_wrapper .apply_goods_box').hide(); 
            if($(this).hasClass("active")){
                 $(this).parents(".coupon_box").find("[tag='cartShops']").removeClass("active")
                $(this).addClass("active")
              }else{
                $(this).parents(".coupon_box").find("[tag='cartShops']").removeClass("active")

            }
            that._model._coupons.map((item, index) => {
                if(index == $(this).attr('code')){
                    arr = item
                }
            })
            let htmls = ''
            $('.apply_goods_box').html('')
            that._model.modifyAppList(arr).then( res =>{
                htmls += `<ul class="clearfix apply_goods_ul tag="apply_goods_ul">
                ${that.getItemApply()}
                </ul>
                <p class="a_sum">${that._model._arr.stip ? that._model._arr.stip : ''}</p>
                <p class="fr a_btn"><button class="le_btn le_btn_solid" tag="onClickOKcancal">确认</button></p>`
                $('.apply_goods_box').append($(htmls));
            }).catch(err => { 
                Alert.showTip(err);
                
            });
            var x = -35;
            var y = 20;
            var left = $(this).parents('.clstop').position().left;
            var top = $(this).parents('.clstop').position().top;
            let arrs = $(this)
            if($(this).hasClass("active")){
              $(this).parents(".content_item").find("[tag='cartShops']").removeClass("active")
              $(this).parents((".apply_good_text")).find(".apply_goods_box").hide()
            }else{
              $(this).addClass("active")
              $(this).parents((".apply_good_text")).find(".apply_goods_box").css({
                  'left': (left + x + 'px'),
                  'top': ( y  + 'px'),
                  'z-index': 9999
              }).show();
            }
         
            var iconfontDom = $(this).find('i.iconfont');
            if(iconfontDom.hasClass('icon-arrow-down')){
                $(this).parents(".content_item").find("[tag='cartShops']").find('i.iconfont').addClass('icon-arrow-down')
                iconfontDom.removeClass('icon-arrow-down').addClass('icon-arrow-up')
            }else{
                iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down')
            }
        })
    }
}


